import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var CannotFindAnOrderIA = function CannotFindAnOrderIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "qs+yOq",
    defaultMessage: [{
      "type": 0,
      "value": "Si vous ne parvenez pas à trouver la commande d'un commerçant sur votre compte Faire, différentes causes sont possibles. Voici quelques actions à entreprendre pour résoudre ce problème :"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "8Hf+hC",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Commande en cours de traitement :"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "+J5CGL",
    defaultMessage: [{
      "type": 0,
      "value": "Demandez au commerçant de fournir toutes les informations dont il pourrait disposer sur son compte et invitez-le à nous contacter directement pour obtenir de l'aide."
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Q7Q0DJ",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Numéros de commande différents :"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "s5nkQH",
    defaultMessage: [{
      "type": 0,
      "value": "Si un commerçant vous donne un numéro de commande qui n'apparaît pas sur votre page "
    }, {
      "children": [{
        "type": 0,
        "value": "Commandes"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": ", demandez-lui plutôt son "
    }, {
      "children": [{
        "type": 0,
        "value": "numéro de facture"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ". Le numéro de facture devrait correspondre au numéro de commande que vous voyez, et vous pourrez identifier la commande."
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return OrderLinkFormatting(chunks);
      },
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "JDfmRL",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Nouveaux comptes en cours de vérification :"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "PDY+PO",
    defaultMessage: [{
      "type": 0,
      "value": "Si un commerçant a fourni son numéro de facture, mais que vous ne trouvez toujours pas sa commande, il est possible que ce commerçant ait un nouveau compte en attente de vérification par notre équipe. Ce processus de vérification ne devrait pas prendre plus de quelques jours."
    }]
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "IkPzxw",
    defaultMessage: [{
      "type": 0,
      "value": "Si vous ne trouvez toujours pas la commande après avoir vérifié ce qui précède, contactez-nous pour obtenir de l'aide. Nous serions ravis de vous aider à résoudre ces problèmes."
    }]
  })));
};
var OrderLinkFormatting = function OrderLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrders(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};